module.exports = __webpack_public_path__ + "svgs/system-jumping.396114d3.svg";